import { List, ListItem, ListItemText, Typography, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

function formatUsd(amount) {
  return `USD $${Number(amount).toFixed(2)}`;
}

export default function PaymentQuotePreview({ quote, isLoading, error }) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, my: 2 }}>
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          {t('loading_payment_amount') || 'Loading amount…'}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="body2" color="error" sx={{ my: 2 }}>
        {error}
      </Typography>
    );
  }

  if (!quote) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: '#f8fafc', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
      <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.6 }}>
        {t('amount_to_pay') || 'Amount to pay'}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ color: '#032C65', mb: quote.lines?.length ? 1.5 : 0 }}>
        {formatUsd(quote.total)}
      </Typography>
      {Array.isArray(quote.lines) && quote.lines.length > 0 && (
        <List dense disablePadding>
          {quote.lines.map((line, i) => (
            <ListItem key={`${line.sacrament_registration_id || i}-${line.concept || i}`} disableGutters sx={{ py: 0.25 }}>
              <ListItemText
                primary={line.description}
                secondary={formatUsd(line.amount)}
                primaryTypographyProps={{ variant: 'body2' }}
                secondaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
}

export async function fetchSacramentPaymentQuote(tracker, hashids) {
  const res = await tracker.get('sacrament-payments/quote', {
    params: { registration_hashids: hashids },
  });
  return res.data;
}
